<script>
import { mapActions, mapGetters } from 'vuex';
import { getContrastingTextColor } from '@chatwoot/utils';
import BaseButton from '../../shared/components/gapify/components/Button/BaseButton.vue';

export default {
  components: {
    BaseButton,
  },
  computed: {
    ...mapGetters({
      widgetColor: 'appConfig/getWidgetColor',
      conversationAttributes: 'conversationAttributes/getConversationParams',
    }),
    textColor() {
      return getContrastingTextColor(this.widgetColor);
    },
    showHandoverButton() {
      return this.conversationAttributes.handover_button_enabled === true;
    },
    buttonText() {
      return (
        this.conversationAttributes.handover_button_text ||
        'اتصال مستقیم به کارشناس'
      );
    },
  },
  methods: {
    ...mapActions('conversation', ['botifyHandover']),
    async handleHandover() {
      try {
        await this.botifyHandover();
      } catch (error) {
        console.error('Error in handleHandover:', error);
      }
    },
  },
};
</script>

<template>
  <div v-if="showHandoverButton" class="px-6 py-2 bg-transparent">
    <div
      class="flex h-12 items-center justify-between p-3 rounded-lg bg-[#F4F4F4] dark:bg-slate-800 [box-shadow:0_0_6px_0_#00000040]"
    >
      <div class="flex items-center gap-2">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15 15.7167H14.3667C13.7 15.7167 13.0667 15.975 12.6 16.4417L11.175 17.85C10.525 18.4917 9.46668 18.4917 8.81668 17.85L7.39166 16.4417C6.925 15.975 6.28333 15.7167 5.625 15.7167H5C3.61667 15.7167 2.5 14.6084 2.5 13.2417V4.14999C2.5 2.78333 3.61667 1.67502 5 1.67502H15C16.3833 1.67502 17.5 2.78333 17.5 4.14999V13.2417C17.5 14.6 16.3833 15.7167 15 15.7167Z"
            stroke="#3A3A3F"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M10 8.33332C11.0724 8.33332 11.9417 7.464 11.9417 6.39164C11.9417 5.31929 11.0724 4.45001 10 4.45001C8.92768 4.45001 8.05835 5.31929 8.05835 6.39164C8.05835 7.464 8.92768 8.33332 10 8.33332Z"
            stroke="#3A3A3F"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M13.3334 13.05C13.3334 11.55 11.8417 10.3333 10.0001 10.3333C8.15841 10.3333 6.66675 11.55 6.66675 13.05"
            stroke="#3A3A3F"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <span class="text-sm font-medium text-slate-800 dark:text-slate-100">
          {{ buttonText }}
        </span>
      </div>
      <BaseButton
        type="fill"
        status="Second gapify"
        size="Small"
        @click="handleHandover"
        :text="$t('HANDOVER_BUTTON.CONNECT')"
        class="no-border"
      />
    </div>
  </div>
</template>

<style scoped>
.no-border :deep(button) {
  border: 0 !important;
}
</style>
